<template>
    <div class="o-contact-card">
        <div class="contact-card__wrapper">
            <figure v-if="contact.image">
                <img class="contact-card__img" :src="contact.image" alt="">
            </figure>
            <div class="contact-card__info">
                <p class="contact-card__title">{{ contact.title }}</p>
                <p>{{ contact.name }}</p>
                <p>Tel: <a :href="`tel:${contact.phoneNumber}`">{{ contact.phoneNumber }}</a></p>
                <p>Email: <a :href="`mailto:${contact.email}`">{{ contact.email }}</a></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContactCard',
        props: {
            contact: Object
        }
    }
</script>

<style scoped lang="scss">
    .o-contact-card {
        width: fit-content;
        margin: 2rem 2rem 2rem 0;
        padding: 1rem 1rem 1rem 0;
    }
    .contact-card__img {
        border-radius: 50%;
        max-height: 100px;
        border: #dddddd 5px solid;
    }
    .contact-card__wrapper {
        display: flex;
        align-items: center;
        @media (max-width: 767px) {
            flex-direction: column;
            text-align: center;
        }
    }
    .contact-card__info {
        color: #003b71;
        margin-left: 1.5rem;
        font-size: 14px;
        line-height: 1.4rem;
        p {
            margin-bottom: 0;
        }
        @media (max-width: 767px) {
            margin-left: 0;
            margin-top: 0.5rem;
        }
    }
    .contact-card__title {
        font-weight: bold;
    }

</style>
